import { type UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { GetUserSettingsResponse } from 'generated/openapi';

import {
  getUserSettingsKey,
  getUserSettingsOptions,
} from './getUserSettings.options';

export interface UseGetUserSettingsProps<T = GetUserSettingsResponse> {
  options?: Omit<
    UseQueryOptions<GetUserSettingsResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetUserSettings<T = GetUserSettingsResponse>(
  props: UseGetUserSettingsProps<T> = {},
) {
  const { options } = props;

  return useSuspenseQuery({
    ...getUserSettingsOptions<T>(),
    ...options,
  });
}

useGetUserSettings.getQueryKey = getUserSettingsKey;
